module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Files/Deleted-folder-355c2cb432e4655ea19bd11c169e349b.svg";